import axios from 'axios';
import {message} from "antd";

// axios.defaults.baseURL = 'http://10.10.250.2:7720'
axios.defaults.baseURL = 'https://yxback.xunmengvip.cn' //测试接口
//axios.defaults.baseURL = 'https://youxuan-api.xunmengvip.com' //线上接口
// axios.defaults.baseURL = 'https://api.xunmengvip.com/youxuan'
axios.defaults.withCredentials = true; // 允许携带cookie
export const MethodType = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH:'PATCH'
};

/**
 * 模块说明:有api_token的请求
 */
export const request = (api, method = MethodType.GET, params = {}, config = {}) => {
  const data = (method === 'GET') ? 'params' : 'data';
  console.log(params)
  console.log(data)
  let headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'usertoken_yx': window.localStorage.getItem('OPEN_ID')
  };
  if (config.headers) {
    headers = {
      ...headers,
      ...config.headers
    }
  }
  return new Promise((resolve, reject) => {
    axios({
      url: api,
      method,
      [data]: params,
      headers,
    }).then(resolve)
      .catch(error => {
        // console.dir(error);
        message.error(JSON.stringify(error.response))
       // message.error(typeof error.response.data === 'string' ? error.response.data : JSON.stringify(error.response.data));
        reject(error);
      });
  });
};





// WEBPACK FOOTER //
// ./src/utils/request.js